import { Row, Form, Radio, DatePicker, Select, Col, Space, Input } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import GetLabel from 'DisplayFramework/components/GetLabel';
import FormInput from 'components/FormInput';
import ButtonLink from 'components/theme_components/ButtonLink';
import TextArea from 'antd/lib/input/TextArea';
import { addParTaxRate, ParTaxResponse2 } from 'services/parametersService';
import ParListSelect from 'components/ParListSelect';
import Notifications from 'components/theme_components/Notifications';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from 'components/Auth/Auth';
import InputRate from 'components/InputRate';
import IBasket from 'icons/IBasket';
import ModalSFS from 'components/theme_components/ModalSFS';
import { toDatePickerDate } from 'utils/utils2';

export type ParTaxeValueModalProps = {
  setVisible: (visible: boolean) => void;
  setAddRateValue?: (addRateValue: boolean) => void;
  data: any;
  refetch: any;
};

const ParTaxeValueModal = ({
  setVisible,
  setAddRateValue,
  data,
  refetch,
}: ParTaxeValueModalProps) => {
  const [form] = useForm();
  const { isInspect } = useContext(AuthContext);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisibleSussp, setModalVisibleSussp] = useState(false);

  const [modalVisibleDelet, setmodalVisibleDelet] = useState(false);
  console.log({ data });
  const id = undefined;
  useEffect(() => {
    if (data) {
      console.log('data', data)
      form.setFieldsValue({
        partaxrate: data.partaxrate,
        taxtype: data.taxtype,
        taxcode: data.taxcode,
        taxflow: data.taxflow,
        taxlabel: data.taxlabel,
        begindate: toDatePickerDate(data.begindate),
        enddate: toDatePickerDate(data.enddate),
        taxdescription: data.taxdescription,

      });
    }
  }, [data]);
  const submit = (values: any) => {
    const request: any = {
      taxcode: data.taxcode,
      begindate: form.getFieldValue('begindate'),
      enddate: form.getFieldValue('enddate'),
      taxrate: form.getFieldValue('partaxrate'),
      taxflow: form.getFieldValue('taxflow'),
      taxdescription: form.getFieldValue('taxdescription'),
    };
    addParTaxRate({ request: request }).then((res) => {
      if (res.code === '200') {
        refetch()
        Notifications({
          status: "success",
          message: 'La taxe a été modifié avec succès',
          description: res.description,
          duration: 3,
          placement: 'top',
        });
        setVisible(false);
      }
      if (res.code === '400') {
        Notifications({
          status: res.code,
          message: res.message,
          description: res.description,
          duration: 3,
          placement: 'top',
        });
      } else {
        setModalVisible(true);
      }
    });
  };

  return (
    <Form form={form} className="no-border-radius ut-wizard-form">
      <Row gutter={16} justify="space-between">
        <FormInput
          col
          xs={11}
          lg={11}
          name="begindate"
          className="form-item no-border-radius"
          layout="vertical"
        >
          <DatePicker
            className="form-item no-border-radius"
            format={{
              format: 'DD-MM-YYYY',
              type: 'mask',
            }}
            onChange={() => {
              form.setFieldValue('enddate', null)
            }}
          />
        </FormInput>
        <FormInput
          col
          xs={11}
          lg={11}
          name="enddate"
          className="form-item no-border-radius"
          layout="vertical"
        >
          <DatePicker
            className="form-item no-border-radius"
            format={{
              format: 'DD-MM-YYYY',
              type: 'mask',
            }}
          />
        </FormInput>
        <FormInput
          col
          xs={24}
          lg={24}
          className="form-item no-border-radius"
          labelCol={{ span: 24 }}
          name="taxlabel"
        >
          <Input disabled />
        </FormInput>
        <FormInput
          name="taxtype"
          col
          xs={24}
          lg={24}
          className="form-item no-border-radius"
          labelCol={{ span: 24 }}
        >
          <ParListSelect parcode="SFSTAXTYPE" disabled />
        </FormInput>
        <FormInput
          col
          xs={24}
          lg={24}
          name="taxflow"
          labelCol={{ span: 24 }}
          className="no-border-radius"
        >
          <ParListSelect parcode="TAXFLOW" disabled />

        </FormInput>
        <FormInput
          col
          xs={24}
          lg={24}
          name="partaxrate"
          labelCol={{ span: 24 }}
          className="no-border-radius "
          rules={[{ required: true }]}

        >
          <InputRate />
        </FormInput>
        <FormInput
          col
          xs={24}
          lg={24}
          name="taxdescription"
          labelCol={{ span: 24 }}
          className=""
        >
          <TextArea size="middle" rows={3} className="texterea mb-50" />
        </FormInput>
      </Row>

      <div className="d-flex justify-between align-center pt-4 mt-8">
        <div>

          <ButtonLink
            className="ut-reset-btn ut-btn-no-border no-box-shadow mr-4 btn-supp "
            comcode="Supptaxe"
            icon={<IBasket />}
            onClick={() => !isInspect && setModalVisibleSussp(true)}
          />

        </div>
        <Space>
          <ButtonLink
            comcode="Annuler"
            className="ut-btn-bordred"
            onClick={() => setVisible(false)}
          />

          <ButtonLink
            type="primary"
            comcode="Valider"
            htmlType="submit"
            className="ut-reset-btn ml-6"
            onClick={(values: any) => {
              submit(values);
            }}
            iconPosition="end"
          />
        </Space>
      </div>
      <ConfirmModal
        visible={modalVisible}
        status="error"
        message="Le taux existe déjà"
        description="Voulez-vous le mettre à jour ?"
        onConfirm={() => {
          setModalVisible(false);
        }}
        onCancel={() => !isInspect && setModalVisible(false)}
        className="modalConfirmOrCancel"
      />
      <ConfirmModal
        visible={modalVisibleSussp}
        status="error"
        message="Êtes-vous sûr de vouloir supprimer cette taxe ?"
        onConfirm={() => {
          setVisible(false)
          setModalVisible(false);
          setModalVisibleSussp(false);
        }}
        onCancel={() => !isInspect && setModalVisibleSussp(false)}
        className="modalConfirmOrCancel"
      />
    </Form>
  );
};

export default ParTaxeValueModal;
